/**
 * 生年月日から「現在の学年」を計算（日本の学年：4月1日基準）
 * 表示用・保存用の grade 文字列を返す
 * @param {string|Date} birthDate - YYYY-MM-DD または Date
 * @returns {string} 年長 | 小1～小6 | 中1～中3 | 高1～高3 | 成人 | その他
 */
export function getGradeFromBirthDate (birthDate) {
  if (!birthDate) return 'その他'
  const birth = typeof birthDate === 'string' ? new Date(birthDate + 'T00:00:00') : new Date(birthDate)
  if (Number.isNaN(birth.getTime())) return 'その他'

  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  // 現在の「年度」の4月1日（年度開始日）
  const schoolYear = month >= 4 ? year : year - 1
  const april1 = new Date(schoolYear, 3, 1)

  let age = april1.getFullYear() - birth.getFullYear()
  // 4月2日以降生まれはその年度の4月1日時点で1歳少ない
  if (birth.getMonth() > 3 || (birth.getMonth() === 3 && birth.getDate() > 1)) {
    age--
  }
  if (age < 0) return 'その他'

  const map = {
    5: '年長',
    6: '小1',
    7: '小2',
    8: '小3',
    9: '小4',
    10: '小5',
    11: '小6',
    12: '中1',
    13: '中2',
    14: '中3',
    15: '高1',
    16: '高2',
    17: '高3'
  }
  if (age >= 18) return '成人'
  return map[age] || 'その他'
}
